<template>
    <Overlay :showOverlay="show" :clearBg="false" @close="show = !show" :title="title" :subtitle="caption">
        <template v-slot:content>
            <div class="careers-overlay__container" v-if="content && content.length > 0">
                <div class="careers-overlay-item" v-for="(card, index) in content" :key="index">
                    <div class="careers-overlay-item__content">
                        <div class="careers-overlay-item__content-wrap">
                            <h3>{{ card.title }}</h3>
                            <div v-html="card.subtitle"></div>
                        </div>
                        <div class="dropdown-button" v-if="card.action.length > 1">
                            <button class="button button--icon" @click="toggleDropdown(index)">Apply <i  class="icon-chevron-down"></i></button>
                            <div class="dropdown-menu" :style="`display: ${activeDropdown === index ? 'block' : 'none'}`">
                                <div v-for="(action, index) in card.action" :key="index" class="dropdown-link"><a :href="action.Url" :target="action.Target">{{action.Name}}</a></div>
                            </div>
                        </div>
                        <a v-if="card.action.length === 1" :href="card.action[0].Url" class="button" :target="card.action[0].Target">{{ card.action[0].Name }}</a>
                    </div>
                </div>
            </div>
        </template>
    </Overlay>
</template>

<script>
import Overlay from "./Global/Overlay.vue"
import eventBus from '../services/eventBus.js';

export default {
    props: ["componentId", "caption", "title", "buttonLabel", "content"],
    components: {
        Overlay
    },
    data() {
        return {
            show: false,
            activeDropdown: null,
        }
    },
    mounted() {
        let self = this;
        document.getElementById(this.componentId).addEventListener("ToggleCareersOverlay", (e) => {
            self.toggleOverlay();
        });
    },
    methods: {
        toggleDropdown: function (index) {
            if (this.activeDropdown === index) {
                this.activeDropdown = null;
            } else {
                this.activeDropdown = index;
            }
        },
        toggleOverlay: function () {
            this.show = !this.show;
        },
    }
}
</script>
